// Shared classification of axios/network errors.
//
// When the backend is down, suspended, or cold-starting, the request never
// gets a readable HTTP response: a suspended Render service returns an error
// page with NO CORS headers, so the browser blocks it and axios surfaces a bare
// "Network Error" with no `response` object (rather than a clean 503). We use
// that to show a reassuring "servers temporarily unavailable" message instead of
// a raw network error, while a real HTTP error (401 bad credentials, 4xx, …)
// still carries its `response` and is shown as-is.
export const isBackendUnreachable = (error) => !error?.response;
